import Http from "@hview/hview-http";

/**
 * @description 获取Dashboard信息
 * @param params
 */
export const getDashboardApi = () => Http.post("/api/v2/doctor/member/Dashboard");
